interface IParams {
  chatsCount: number;
  syncPageSize: number;
}

export const getSyncPagesByChats = ({ chatsCount, syncPageSize }: IParams) => Math.ceil(chatsCount / syncPageSize);
